import { inject, Injectable, NgZone } from '@angular/core';
import posthog, { Properties } from 'posthog-js';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class PosthogService {
  #zone = inject(NgZone);

  initPostHog() {
    this.#zone.runOutsideAngular(() => {
      posthog.init(environment.posthogKey, {
        api_host: environment.posthogHost,
        defaults: '2025-05-24',
      });
    });
  }

  setPersonProperties(userPropertiesToSet?: Properties, userPropertiesToSetOnce?: Properties) {
    this.#zone.runOutsideAngular(() => {
      posthog.setPersonProperties(userPropertiesToSet, userPropertiesToSetOnce);
    });
  }

  identify(distinctId: string, userPropertiesToSet?: Properties, userPropertiesToSetOnce?: Properties) {
    this.#zone.runOutsideAngular(() => {
      posthog.identify(distinctId, userPropertiesToSet, userPropertiesToSetOnce);
    });
  }
}
